import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { message } from "antd";

export default function UserBookingCard(props) {
  // Setting up the message from antd
  const [messageApi, contextHolder] = message.useMessage();

  // State Handling
  const [loading, setLoading] = useState(false);

  // Setting the Payment Error
  const paymentNotDoneAlert = () => {
    messageApi.open({
      type: "error",
      content: "Payment Error",
      duration: 2,
    });
  };

  // Making Payment Function
  const makePaymentNow = async () => {
    setLoading(true);
    try {
      const stripe = await loadStripe(
        "pk_test_51OmhNjD3yW8DPSzpoRzkAgnif1Uxt4PPTEO8UqVK8wHwYzRiTvejXIutvMWn8tGAnu61efAkIiUNAFA8Gpv7a8TV000w9DYTgs"
      );
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/confirm-booking",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(props.bookingObject),
        }
      );

      // Checking Response
      if (response.ok) {
        const session = await response.json();
        const result = stripe.redirectToCheckout({
          sessionId: session.id,
        });
      } else if (!response.ok) {
        paymentNotDoneAlert();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {contextHolder}
      <div className="col-lg-4 col-md-6 col-12 mb-md-4 mb-5 single-booking px-2">
        <div className="inner-cover">
          <div
            className="image-side"
            style={{ background: `url(${props.img})` }}
          ></div>
          <div className="details-side mt-3">
            {/* Booking Details Start */}
            <h4 className="mb-4">Booking Details</h4>
            <p className="mb-0">
              <span>Name:</span> {props.bookingHolderName}
            </p>
            <p className="mb-0">
              <span>Booking Id:</span> {props.bookingId}
            </p>
            <p className="mb-0">
              <span>From:</span> {props.fromDate.split("T")[0]}
            </p>
            <p className="mb-0">
              <span>To:</span> {props.toDate.split("T")[0]}
            </p>
            <p className="mb-0">
              <span>Hotel:</span> {props.hotelName}
            </p>
            <p className="mb-0">
              <span>Room:</span> {props.room}
            </p>
            <p className="mb-0">
              <span>Rent Per Day:</span> ${props.rentPerDay}
            </p>
            <p className="mb-0">
              <span>Total Amount:</span> ${props.totalAmount}
            </p>
            <p className="mb-0">
              <span>Status:&nbsp;&nbsp;</span>
              <span
                className={`custom-badge custom-booking-badge mb-2 ${
                  props.bookingStatus === "Pending" && "pending-badge"
                } ${props.bookingStatus === "Active" && "active-badge"} ${
                  props.bookingStatus === "Cancelled" && "cancel-badge"
                } ${props.bookingStatus === "Expired" && "expire-badge"}`}
              >
                {props.bookingStatus}
              </span>
            </p>
            {/* Booking Details End */}

            {/* Button */}
            {props.bookingStatus === "Pending" && !loading ? (
              <button
                className="btn pay-btn custom-btn rounded-pill"
                onClick={makePaymentNow}
              >
                Pay Now
              </button>
            ) : ""}
            {props.bookingStatus === "Active" && (
              <button className="btn pay-btn custom-btn rounded-pill" disabled>
                Confirmed
              </button>
            )}
            {props.bookingStatus === "Cancelled" && (
              <button className="btn pay-btn custom-btn rounded-pill" disabled>
                Cancelled
              </button>
            )}

            {props.bookingStatus === "Expired" && (
              <button className="btn pay-btn custom-btn rounded-pill" disabled>
                Expired
              </button>
            )}
            
            {loading && (
                <div className="spinner-grow" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
